import { useCallback, useEffect, useState } from 'react'

import { BaselineCandidatePackage, BaselinePackage, Package } from '@instabox/lockers-update-common/types'

import { sortPackages } from '../utils/baseline'

interface UseProcessBaselineChanges {
  totalChanges: number
  processedBaseline: BaselineCandidatePackage[]
}

const useProcessBaselineChanges = (
  currentBaselinePkgs: Package[],
  newBaselinePkgs: BaselinePackage[]
): UseProcessBaselineChanges => {
  const [totalChanges, setTotalChanges] = useState<number>(0)
  const [processedBaseline, setProcessedBaseline] = useState<BaselineCandidatePackage[]>([])

  const processChanges = useCallback(() => {
    let changesCount = 0
    const processedNewBaseline: BaselineCandidatePackage[] = []

    currentBaselinePkgs.forEach((baselinePkg) => {
      const currentBaselinePkgInNewBaselineArray = newBaselinePkgs.filter(({ name }) => name === baselinePkg.name)
      if (!currentBaselinePkgInNewBaselineArray.length) {
        processedNewBaseline.push({
          ...baselinePkg,
          type: 'error',
          message: `Version ${baselinePkg.version} will be removed from baseline!`,
        })
        changesCount++
        return
      }

      const newPackage = currentBaselinePkgInNewBaselineArray[0]

      if (newPackage.selectedVersion !== baselinePkg.version) {
        processedNewBaseline.push({
          ...baselinePkg,
          type: 'warning',
          message: `Version ${baselinePkg.version} changing to ${newPackage.selectedVersion}`,
        })
        changesCount++
        return
      }

      processedNewBaseline.push({
        ...baselinePkg,
        type: 'info',
        message: `Version ${newPackage.selectedVersion} will be kept - no changes`,
      })
    })

    newBaselinePkgs.forEach((newPkg) => {
      if (!currentBaselinePkgs.filter(({ name }) => name === newPkg.name).length) {
        processedNewBaseline.push({
          ...newPkg,
          type: 'success',
          message: `Version ${newPkg.selectedVersion} will be added to baseline`,
        })
        changesCount++
      }
    })

    processedNewBaseline.sort(sortPackages)

    setTotalChanges(changesCount)
    setProcessedBaseline(processedNewBaseline)
  }, [currentBaselinePkgs, newBaselinePkgs])

  useEffect(processChanges, [currentBaselinePkgs, newBaselinePkgs, processChanges])

  return {
    totalChanges,
    processedBaseline,
  }
}
export default useProcessBaselineChanges
